import templateUrl from './editor-template-overview.html';
import last from 'lodash/last';

export const editorTemplateOverviewComponent = {
	bindings: {
		details: '<',
		slugUrl: '@',
		parentSlug: '@',
		parentName: '@'
	},

	templateUrl,

	controller: class EditorTemplateOverviewComponent {
		constructor($state, $timeout, toastr, CompareObjectService, ModalService, EditorTemplateOverviewService, DynamicMenusService, DashboardService) {
			'ngInject';

			this.$state = $state;
			this.$timeout = $timeout;
			this.toastr = toastr;
			this.compareObjectService = CompareObjectService;
			this.modalService = ModalService;
			this.editorTemplateOverviewService = EditorTemplateOverviewService;
			this.dynamicMenusService = DynamicMenusService;
			this.dashboardService = DashboardService;
		}

		$onInit() {
			this.details = this.editorTemplateOverviewService.getEditorContentOverviewDetails(this.details);
			this.isDescriptionAvailable = this._isDescriptionShowInOverview();
			this.details.pageTitle = "Edit Overview";
			this.savedData = angular.copy(this.details);
		}

		onCoverPicUpload({ details: { uuid } }) {
			this.details.image = uuid;
		}

		onCancel() {
			const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details, false);

			if (isUpdated) {
				this.modalService.open({
					details: {
						bodyMessage: 'Changes done will be reverted. Continue?'
					},
					buttons: [{
						name: 'No'
					}, {
						name: 'Yes',
						isPrimary: true,
						action: _onSubmit.bind(this)
					}]
				});

				function _onSubmit() {
					this._redirectToParentState(this.parentSlug);
				}
			} else {
				this._redirectToParentState(this.parentSlug);
			}
		}

		onSubmit() {
			const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.savedData, this.details, true);

			if (isUpdated) {
				this.editorTemplateOverviewService.updateEditorContentOverviewDetails(this.details, this.parentName)
					.then((details) => {
						this.toastr.success('Overview updated successfully');
						const { breadcrumb } = details;
						const menu = last(breadcrumb);
						this._updateMenuList(menu);
						this._redirectToParentState(menu.slug);
						this._reloadMenuList();
						this.disableButtons = false;
					}).catch((err) => {
						this.toastr.error(err);
						this.disableButtons = false
					});
			}
			else {
				this.toastr.success('Nothing to update');
				this._redirectToParentState(this.parentSlug);
				this.disableButtons = false;
			}
		}

		//-------------------------------------Private Methods----------------------------------------------------

		_updateMenuList(menu) {
			this.dashboardService.updateMenuSlug(menu);
		}

		_redirectToParentState(slug) {
			this.$state.go('app.dashboard.DynamicMenus', {
				url: slug
			});
		}

		_reloadMenuList() {
			this.$timeout(() => {
				this.$state.reload();
			}, 500);
		}

		// Display description in overview if true
		_isDescriptionShowInOverview() {
			switch (this.parentName) {
				case 'TelemedicineDeliveryProgramAssistance':
				case 'ConnectionToCare':
				case 'GettingThere':
				case 'NewsRuralMobilityProject':
				case 'PlanningAndTechnicalAssistance':
				case 'VoucherProgram':
				case 'TravelTrainingGetting':
				case 'CallCenter':
				case 'MissionHistory':
				case 'RuralHealthNetwork':
				case 'PartnersStakeholders':
				case 'AdvisoryCommittee':
				case 'Industry':
				case 'TransportationLinks':
				case 'GrantApplications':
				case 'OtherReferenceMaterialsFunding':
				case 'Page1':
				case 'Page2':
				case 'Page3':
				case 'Page4':
				case 'Page5':
				case 'DataMappingTool':
					return false
				default:
					return true;
			}
		}
	}
};


// WEBPACK FOOTER //
// ./src/app/components/editor-template-overview/editor-template-overview.component.js